/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The UserProfileSettings model module.
 * @module model/UserProfileSettings
 * @version 0.0.2
 */
export class UserProfileSettings {
  /**
   * Constructs a new <code>UserProfileSettings</code>.
   * @alias module:model/UserProfileSettings
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UserProfileSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserProfileSettings} obj Optional instance to populate.
   * @return {module:model/UserProfileSettings} The populated <code>UserProfileSettings</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserProfileSettings();
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('username'))
        obj.username = ApiClient.convertToType(data['username'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('birthday'))
        obj.birthday = ApiClient.convertToType(data['birthday'], 'Date');
      if (data.hasOwnProperty('fullname'))
        obj.fullname = ApiClient.convertToType(data['fullname'], 'String');
      if (data.hasOwnProperty('dateTimeCreated'))
        obj.dateTimeCreated = ApiClient.convertToType(data['dateTimeCreated'], 'Date');
      if (data.hasOwnProperty('street'))
        obj.street = ApiClient.convertToType(data['street'], 'String');
      if (data.hasOwnProperty('locationName'))
        obj.locationName = ApiClient.convertToType(data['locationName'], 'String');
      if (data.hasOwnProperty('zipcode'))
        obj.zipcode = ApiClient.convertToType(data['zipcode'], 'Number');
      if (data.hasOwnProperty('deutschlandticketUsed'))
        obj.deutschlandticketUsed = ApiClient.convertToType(data['deutschlandticketUsed'], 'Boolean');
      if (data.hasOwnProperty('bahncardPercent'))
        obj.bahncardPercent = ApiClient.convertToType(data['bahncardPercent'], 'Number');
      if (data.hasOwnProperty('maxOepvChanges'))
        obj.maxOepvChanges = ApiClient.convertToType(data['maxOepvChanges'], 'Number');
      if (data.hasOwnProperty('maxOepvChanges25Km'))
        obj.maxOepvChanges25Km = ApiClient.convertToType(data['maxOepvChanges25Km'], 'Number');
      if (data.hasOwnProperty('maxOepvChanges50Km'))
        obj.maxOepvChanges50Km = ApiClient.convertToType(data['maxOepvChanges50Km'], 'Number');
      if (data.hasOwnProperty('maxOepvChanges100Km'))
        obj.maxOepvChanges100Km = ApiClient.convertToType(data['maxOepvChanges100Km'], 'Number');
    }
    return obj;
  }
}

/**
 * unique database ID of the user
 * @member {String} userId
 */
UserProfileSettings.prototype.userId = undefined;

/**
 * unique identification name
 * @member {String} username
 */
UserProfileSettings.prototype.username = undefined;

/**
 * unique email of the user
 * @member {String} email
 */
UserProfileSettings.prototype.email = undefined;

/**
 * birthday of the user to select the right oepv ticket for him
 * @member {Date} birthday
 */
UserProfileSettings.prototype.birthday = undefined;

/**
 * full or name part of the user
 * @member {String} fullname
 */
UserProfileSettings.prototype.fullname = undefined;

/**
 * time when the user profile was created
 * @member {Date} dateTimeCreated
 */
UserProfileSettings.prototype.dateTimeCreated = undefined;

/**
 * street name and optionally number of the home address of the user
 * @member {String} street
 */
UserProfileSettings.prototype.street = undefined;

/**
 * location name of the home address of the user
 * @member {String} locationName
 */
UserProfileSettings.prototype.locationName = undefined;

/**
 * zip-code of the home address of the user
 * @member {Number} zipcode
 */
UserProfileSettings.prototype.zipcode = undefined;

/**
 * whether user posseses Deutschlandticket
 * @member {Boolean} deutschlandticketUsed
 */
UserProfileSettings.prototype.deutschlandticketUsed = undefined;

/**
 * type of bahncard user posses if any, like 25, 50, 100
 * @member {Number} bahncardPercent
 */
UserProfileSettings.prototype.bahncardPercent = undefined;

/**
 * max number of oepv changes possible
 * @member {Number} maxOepvChanges
 */
UserProfileSettings.prototype.maxOepvChanges = undefined;

/**
 * max number of oepv changes possible
 * @member {Number} maxOepvChanges25Km
 */
UserProfileSettings.prototype.maxOepvChanges25Km = undefined;

/**
 * max number of oepv changes possible
 * @member {Number} maxOepvChanges50Km
 */
UserProfileSettings.prototype.maxOepvChanges50Km = undefined;

/**
 * max number of oepv changes possible
 * @member {Number} maxOepvChanges100Km
 */
UserProfileSettings.prototype.maxOepvChanges100Km = undefined;

